import { format, isBefore } from 'date-fns'
import React from 'react'
import { Typography } from 'antd'
const { Text } = Typography

const isExpired = (date) => {
  return date && isBefore(new Date(date), new Date())
}

const EndDate = ({date}) => {
  let expDateStr = ""
  let expired = false
  if (date) {
    expDateStr = format(new Date(date), 'MMMM do, yyyy H:mm')
    if (isExpired(date)) {
      expired = true
    }
  } else {
    return <Text type="secondary" italic>n/a</Text>
  }
  
  return (
    <>
      {expDateStr}{expired && <span className="signature-expired-badge"> EXPIRED</span>}
    </>
  )
}

export default EndDate